<!-- 专栏卡片-大 -->
<template>
    <div class="special-column-card">
        <!-- 封面 -->
        <div class="cover">
            <img :src="cardInfo.img || defaultPic"/>
        </div>
        <div class="info-wrapper">
            <!-- 标题 -->
            <div class="title">{{ cardInfo.name }}</div>
            <!-- 简介 -->
            <div class="desc">{{ cardInfo.desc }}</div>
            <div class="nums" v-if="cardInfo.item_cnt && cardInfo.study_cnt">
                <div class="nums-item" v-if="cardInfo.item_cnt">
                    {{ formatNumEn(cardInfo.item_cnt) }}节课
                </div>
                <div class="line" v-if="cardInfo.item_cnt && cardInfo.study_cnt"></div>
                <div class="nums-item" v-if="cardInfo.study_cnt">
                    {{ formatNumEn(cardInfo.study_cnt) }}次学习
                </div>
            </div>
            <div class="btn" @click="clickBtn">去学习</div>
        </div>
    </div>
</template>

<script>
import {formatNumEn} from '@/utils/util';
import {defaultPic} from '../utils/index';

export default {
    name: 'special-column-card-big',
    props: {
        cardInfo: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            defaultPic
        };
    },
    methods: {
        formatNumEn,

        /**
         * 点击去学习按钮
         */

        clickBtn() {
            let url = localStorage.getItem(`lastStudyCourseUrl-${this.cardInfo.id}`);
            this.$emit('clickStudy', {id: this.cardInfo.id, url});
        }
    }
};
</script>

<style lang='less' scoped>
.special-column-card {
    background: #F6F8F9;
    border-radius: 8px;
    width: 100%;
    display: flex;
    padding: 18px;
    height: 245px;

    .cover {
        img {
            height: 209px;
            width: 373px;
            border-radius: 8px;
        }
    }

    .info-wrapper {
        padding-left: 24px;
        position: relative;
        flex: 1;

        .title {
            font-family: PingFangSC-Medium;
            font-size: 24px;
            color: #333333;
            letter-spacing: 0;
            line-height: 34px;
            font-weight: 500;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
        }

        .desc {
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #000;
            letter-spacing: 0;
            line-height: 26px;
            font-weight: 400;
            margin-top: 10px;
        }

        .nums {
            display: flex;
            position: absolute;
            bottom: 14px;
            height: 16px;

            .nums-item {
                font-family: PingFangSC-Regular;
                font-size: 16px;
                color: #999;
                letter-spacing: 0;
                line-height: 16px;
                font-weight: 400;
            }

            .line {
                margin: auto 7px;
                height: 12px;
                width: 1px;
                background-color: rgba(153, 153, 153, 1);
            }
        }

        .btn {
            width: 100px;
            height: 40px;
            background: #05f;
            font-size: 14px;
            line-height: 40px;
            text-align: center;
            color: #fff;
            border-radius: 5px;
            position: absolute;
            right: 6px;
            bottom: 0;
            cursor: pointer;
        }
    }
}
</style>
